import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from './store'

Vue.use(VueRouter)

const Page500 = resolve => require(['./pages/errors/Page500'], resolve)
const Page404 = resolve => require(['./pages/errors/Page404'], resolve)
const PageLogin = resolve => require(['./pages/auth/PageLogin'], resolve)
// const PageRegistration = resolve => require(['./pages/auth/PageRegistration'], resolve)
const PageNewRegistration = resolve => require(['./pages/auth/PageNewRegistration'], resolve)

const PageMyAccount = resolve => require(['./pages/PageMyAccount'], resolve)
const PageMyRentsDetails = resolve => require(['./pages/PageMyRentsDetails'], resolve)

const PageHome = resolve => require(['./pages/PageHome'], resolve)
const PageSubcategory = resolve => require(['./pages/PageSubcategory'], resolve)
const PageProduct = resolve => require(['./pages/PageProduct'], resolve)
const PageCheckout = resolve => require(['./pages/PageCheckout'], resolve)
const PageRentSent = resolve => require(['./pages/PageRentSent'], resolve)

const routes = [
  {path: '/', component: PageHome, name: 'home'},
  {path: '/login', component: PageLogin, name: 'login'},
  {path: '/registration/:clientId?', component: PageNewRegistration, name: 'new_registration'},
  // {path: '/registration/:clientId', component: PageRegistration, name: 'registration'},
  {path: '/my-account', component: PageMyAccount, name: 'my_account'},
  {path: '/my-rents/:rentId', component: PageMyRentsDetails, name: 'my_rents_details'},
  {path: '/subcategory/:subcategorySlug/:subcategoryId', component: PageSubcategory, name: 'subcategory'},
  {path: '/product/:productSlug/:productId', component: PageProduct, name: 'product'},
  {path: '/checkout/:skuId', component: PageCheckout, name: 'checkout'},
  {path: '/rent-sent/:rentPreRegistrationId', component: PageRentSent, name: 'rent_sent'},
  {path: '*', component: Page500, name: 'error500'},
  {path: '*', component: Page404, name: 'error404'}
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  // Hide and Show HTML elements to cleaner page to keep user focus
  if (['subcategory', 'checkout', 'rent_sent', 'my_account', 'my_rents_details'].includes(to.name)) {
    window.parent.postMessage({hide: true}, '*')
  } else {
    window.parent.postMessage({show: true}, '*')
  }
  // Change the scroll of the parent to the original position
  // It will be changed on every route
  if (from.name) {
    window.parent.postMessage({scroll: true}, '*')
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router.js